'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "mw-keybindings/DefaultKeys",
    "dojo/keys",
    "mw-filename-utils/FileNameUtil",
    "util",
    "dojo/i18n!nls/mldoStringResource"
], function (declare, Action, DefaultKeys, keys, FileNameUtil, Util, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        let context = args.context;
        let makeActionAvailable = args.showAction || false;
        this.name = MLDOStrings.contextMenuOpenLabel;
        this.label = MLDOStrings.contextMenuOpenLabel;
        this.enabled = makeActionAvailable;
        this.id = "mldoOpenAction";
        this.allowSubMenu = true;
        this.childActionIds = ["mldoOpenInMOAction", "mldoOpenInMDAction"];
        this.section = {
            id: "MISC",
            name: "MISC",
            allowSubMenu: true,
            forceSubMenu: false
        };
        this.isApplicableTo = function (path) {
          // Hide Open in MATLAB dropdown when on small screen
          if (window.innerWidth <= 768) {
            this.enabled = false;
            return false;
          }
          let selectedFileCount = context.getSelectedRowCount();
          if (selectedFileCount > 1) {
                this.enabled = false;
          } else {
            let fileInfos = context.getSelectedItemFileInfos();
            let fileInfo = fileInfos[0];
              // Enable action if nothing selected, for folders and applicable files
              if (!fileInfo || fileInfo.isDirectory || context.canOpenInMatlabOnline(FileNameUtil.getFileNameExtension(fileInfo.name))) {
                  this.enabled = makeActionAvailable && true;
              } else {
                  this.enabled = false;
              }
          }
          return this.enabled;
        };
    }
  });

});
